<template functional>
    <div :class="['award-logos', 'text--center', props.classes]">
        <img 
            loading="lazy"
            :src="props.src" 
            :alt="`
                Doane Grant Thornton LLP is proud to be recognized as one of 
                Canada's best workplaces for our ${props.year} consecutive year!
            `"
        >
    </div>
</template>

<script>
export default {
    props: {
        year: {
            type: String,
            default: '18th'
        },
        classes: {
            type: String,
            default: ''
        },
        src: {
            type: String,
            default: '/static/stories/belong/award-winning/Award_Winning_26.png'
        },
    },
}
</script>

<style lang="scss" scoped>
.award-logos {
    margin-bottom: 140px;
    margin-top: 60px;

    img {
        max-height: 82px;
    }

    @media (max-width: 767px) {
        margin-top: 30px;
        margin-bottom: 100px;
    }
}
</style>